// extracted by mini-css-extract-plugin
module.exports = {"item":"_02712f2b3b--item--SDkD7","title":"_02712f2b3b--title--HKJkC"};